import { useEffect, useRef } from 'react';
import analytics from '../services/AnalyticsService';

// Fires a page-view analytics event exactly once per mount.
//
// React 18 StrictMode double-invokes effects in development to surface
// side-effect bugs; the `firedRef` guard ensures the event still emits
// only once per real mount. The dependency array intentionally lists
// `eventName` only — `extraProps` would re-fire if a caller passed a
// new object identity on every render.
export default function usePageView(eventName, extraProps) {
  const firedRef = useRef(false);

  useEffect(() => {
    if (!eventName) return;
    if (firedRef.current) return;
    firedRef.current = true;
    analytics.track(eventName, extraProps || {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventName]);
}
